export const bulletStringify = data => '\u2022 ' + data.join('\n\u2022 ');

export const getErrorValue = (errors, fieldName) =>
  errors && errors.hasOwnProperty(fieldName) ? errors[fieldName] : false;

export const defaultRejectHandler = promise => {
  return promise.catch(error => console.error(error));
};

export const stringifyErrorMessage = errorMessage => {
  // errorMessage can be
  //   null,
  //   { detail: 'error' },
  //   { name: 'required', quantity: 'min value error' },
  if (!errorMessage) return '';
  if (errorMessage.hasOwnProperty('detail')) {
    return bulletStringify([errorMessage.detail]);
  }
  return Object.entries(errorMessage)
    .map(([key, value]) => '\u2022 ' + key + ': ' + value)
    .join('\n');
};

export const getStatusStyle = (status) => {
  const statusMapper = {
    unset: 'status-pending',
    failed: 'status-failed',
    passed: 'status-passed',
  };
  return `project-status-text ${statusMapper[status.toLowerCase()]}`;
};

export const createPdf = reportUrl => {
  const link = document.createElement('a');
  link.href = reportUrl;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const toKilo = number => number / 1000.0;

export const fromKilo = number => number * 1000.0;

export const toCenti = number => number * 100.0;

export const fromCenti = number => number / 100.0;

export const toMilli = number => number * 1000.0;

export const fromMilli = number => number / 1000.0;

const KneedToConvertUnit = 'KBTU';

export const toCoolingCap = (value, unit) => {
  return unit === KneedToConvertUnit ? toKilo(value) : value;
};

export const fromCoolingCap = (value, unit) => {
  return unit === KneedToConvertUnit ? fromKilo(value) : value;
};

export const convertRangeFilter = filter => {
  if (!filter) {
    return {};
  }

  return Object.keys(filter).reduce((params, attr) => {
    const min = filter[attr]['min'];
    const max = filter[attr]['max'];
    let newParams = {};
    if (min) {
      newParams[`${attr}__gte`] = min;
    }
    if (max) {
      newParams[`${attr}__lte`] = max;
    }
    return {
      ...params,
      ...newParams,
    };
  }, {});
};

export const withDefaultSort = sorted => {
  return sorted && sorted.length > 0
    ? sorted
    : [{ id: 'is_public', desc: false }, { id: 'modified_date', desc: true }];
};

export const has_value = value => {
  return value !== undefined && value !== null;
};



// WEBPACK FOOTER //
// ./src/utils/utility.js